import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "statistics-page" };
const _hoisted_2 = {
    key: 0,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_3 = {
    key: 1,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_4 = {
    key: 2,
    class: "loading-state"
};
const _hoisted_5 = {
    class: "metrics-grid",
    "aria-label": "Inventory summary"
};
const _hoisted_6 = { class: "metric-card" };
const _hoisted_7 = { class: "metric-icon purple-icon" };
const _hoisted_8 = { class: "metric-copy" };
const _hoisted_9 = { class: "metric-card" };
const _hoisted_10 = { class: "metric-icon blue-icon" };
const _hoisted_11 = { class: "metric-copy" };
const _hoisted_12 = { class: "metric-card" };
const _hoisted_13 = { class: "metric-icon navy-icon" };
const _hoisted_14 = { class: "metric-copy" };
const _hoisted_15 = { class: "metric-card" };
const _hoisted_16 = { class: "metric-icon alert-icon" };
const _hoisted_17 = { class: "metric-copy" };
const _hoisted_18 = { class: "detail-grid" };
const _hoisted_19 = {
    ref: "categoryPanel",
    class: "panel",
    "data-lazy-section": "categories"
};
const _hoisted_20 = { class: "panel-header" };
const _hoisted_21 = { class: "panel-count" };
const _hoisted_22 = {
    key: 0,
    class: "category-list"
};
const _hoisted_23 = { class: "category-label" };
const _hoisted_24 = {
    class: "bar-track",
    "aria-hidden": "true"
};
const _hoisted_25 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_26 = {
    key: 1,
    class: "lazy-placeholder",
    "aria-hidden": "true"
};
const _hoisted_27 = {
    ref: "lowStockPanel",
    class: "panel low-stock-panel",
    "data-lazy-section": "lowStock"
};
const _hoisted_28 = { class: "panel-header" };
const _hoisted_29 = { class: "panel-count alert-count" };
const _hoisted_30 = {
    key: 0,
    class: "low-stock-list"
};
const _hoisted_31 = { class: "stock-item-copy" };
const _hoisted_32 = { class: "stock-quantity" };
const _hoisted_33 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_34 = {
    key: 2,
    class: "list-footnote"
};
const _hoisted_35 = {
    key: 1,
    class: "lazy-placeholder",
    "aria-hidden": "true"
};
const _hoisted_36 = {
    ref: "ordersPanel",
    class: "panel orders-panel",
    "data-lazy-section": "orders"
};
const _hoisted_37 = { class: "panel-header" };
const _hoisted_38 = {
    key: 0,
    class: "order-summary"
};
const _hoisted_39 = { class: "order-total" };
const _hoisted_40 = {
    key: 0,
    class: "status-list"
};
const _hoisted_41 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_42 = {
    key: 1,
    class: "lazy-placeholder orders-placeholder",
    "aria-hidden": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Package = _resolveComponent("Package");
    const _component_Boxes = _resolveComponent("Boxes");
    const _component_CircleDollarSign = _resolveComponent("CircleDollarSign");
    const _component_TriangleAlert = _resolveComponent("TriangleAlert");
    const _component_ClipboardList = _resolveComponent("ClipboardList");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[13] || (_cache[13] = _createStaticVNode("<header class=\"page-header\" data-v-4db1b7fe><div data-v-4db1b7fe><p class=\"eyebrow\" data-v-4db1b7fe>BUSINESS OVERVIEW</p><h1 data-v-4db1b7fe>Statistics</h1><p class=\"page-description\" data-v-4db1b7fe>A live view of stock health and recorded orders.</p></div><span class=\"live-label\" data-v-4db1b7fe><span class=\"live-dot\" data-v-4db1b7fe></span>Live data</span></header>", 1)),
        (_ctx.inventoryError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.inventoryError), 1))
            : _createCommentVNode("", true),
        (_ctx.ordersError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.ordersError), 1))
            : _createCommentVNode("", true),
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading statistics..."))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("section", _hoisted_5, [
                    _createElementVNode("article", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_Package, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[0] || (_cache[0] = _createElementVNode("p", null, "Inventory items", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.inventory.length), 1),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Unique product records", -1))
                        ])
                    ]),
                    _createElementVNode("article", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_Boxes, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Units in stock", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.totalUnits)), 1),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Across all inventory items", -1))
                        ])
                    ]),
                    _createElementVNode("article", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_CircleDollarSign, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Stock value", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.stockValue)), 1),
                            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Current stock at regular price", -1))
                        ])
                    ]),
                    _createElementVNode("article", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_TriangleAlert, {
                                size: 20,
                                "aria-hidden": "true"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Low stock", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.lowStockItems.length), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("span", null, "At or below reorder threshold", -1))
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_18, [
                    _createElementVNode("article", _hoisted_19, [
                        _createElementVNode("header", _hoisted_20, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                                _createElementVNode("p", { class: "eyebrow" }, "ASSORTMENT"),
                                _createElementVNode("h2", null, "Items by category")
                            ], -1)),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.categoryStats.length) + " categories", 1)
                        ]),
                        (_ctx.sectionsVisible.categories)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.categoryStats.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryStats, (category) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: category.name,
                                                class: "category-row"
                                            }, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("span", null, _toDisplayString(category.name), 1),
                                                    _createElementVNode("strong", null, _toDisplayString(category.count), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", {
                                                        class: "bar-fill",
                                                        style: _normalizeStyle({ width: `${category.percent}%` })
                                                    }, null, 4)
                                                ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_25, "Add inventory items to see category totals."))
                            ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (line) => {
                                    return _createElementVNode("span", { key: line });
                                }), 64))
                            ]))
                    ], 512),
                    _createElementVNode("article", _hoisted_27, [
                        _createElementVNode("header", _hoisted_28, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                                _createElementVNode("p", { class: "eyebrow" }, "REPLENISHMENT"),
                                _createElementVNode("h2", null, "Low-stock items")
                            ], -1)),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.lowStockItems.length) + " items", 1)
                        ]),
                        (_ctx.sectionsVisible.lowStock)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.lowStockItems.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lowStockItems.slice(0, 6), (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: item.id,
                                                class: "stock-row"
                                            }, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("strong", null, _toDisplayString(item.name || 'Unnamed item'), 1),
                                                    _createElementVNode("span", null, _toDisplayString(item.internalSku || 'No SKU'), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_32, [
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(item.stock)), 1),
                                                    _createElementVNode("span", null, "of " + _toDisplayString(_ctx.formatNumber(item.lowStockThreshold)), 1)
                                                ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_33, "No items are currently at or below their threshold.")),
                                (_ctx.lowStockItems.length > 6)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Showing 6 of " + _toDisplayString(_ctx.lowStockItems.length) + " low-stock items ", 1))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (line) => {
                                    return _createElementVNode("span", { key: line });
                                }), 64))
                            ]))
                    ], 512)
                ]),
                _createElementVNode("section", _hoisted_36, [
                    _createElementVNode("header", _hoisted_37, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                            _createElementVNode("p", { class: "eyebrow" }, "ORDER ACTIVITY"),
                            _createElementVNode("h2", null, "Recorded orders")
                        ], -1)),
                        _createVNode(_component_ClipboardList, {
                            size: 20,
                            class: "orders-icon",
                            "aria-hidden": "true"
                        })
                    ]),
                    (_ctx.sectionsVisible.orders)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Total orders", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.orders.length), 1)
                            ]),
                            (_ctx.orderStatusStats.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStatusStats, (status) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: status.name,
                                            class: "status-row"
                                        }, [
                                            _createElementVNode("span", null, [
                                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "status-dot" }, null, -1)),
                                                _createTextVNode(_toDisplayString(status.name), 1)
                                            ]),
                                            _createElementVNode("strong", null, _toDisplayString(status.count), 1)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_41, "Order status totals will appear when order records exist."))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (line) => {
                                return _createElementVNode("span", { key: line });
                            }), 64))
                        ]))
                ], 512)
            ], 64))
    ]));
}
